import { ConfigurationService } from 'src/app/core/services/configuration.service';
import { PrivacyAgreementService } from './../../../core/services/privacy-agreement.service';
import { LoginService } from 'src/app/core/services/login.service';
import { AuthorizationProperties } from './../../../authentication/auth-info';
import { Component, OnInit } from '@angular/core';
import { TranslatedVariables } from 'src/app/commons/translated-variables';
import { BreakpointObserver, BreakpointState } from '@angular/cdk/layout';
import { StepperOrientation } from '@angular/material/stepper';
import { Observable } from 'rxjs';
import { map } from 'rxjs/operators';
import { CustomerService } from 'src/app/core/services/customer.service';
import { AdministrativeInfoContainer } from './../../../model/AdministrativeInfo';
import { Subscription } from 'rxjs';
import { ServiceUtilsService } from 'src/app/core/services/service-utils.service';
import { LoadingService } from 'src/app/core/services/loading.service';
import { MagoWebService } from 'src/app/core/services/mago-web.service';
import { ActivatedRoute, Params } from '@angular/router';
import { StoreRolesService } from 'src/app/core/services/store-role.service';
import { ConfigurationType } from 'src/app/model/configuration';
import { WorkFlowService } from 'src/app/core/services/work-flow.service';
import { CmsObject } from 'src/app/model/cmsobject';
import { CmsService } from 'src/app/core/services/cms.service';
import { ProductService } from 'src/app/core/services/product.service';
import { IndustryProductID, ProductCode } from 'src/app/model/industry';
import { Mode } from 'src/app/model/subscription';

@Component({
    selector: 'ms-magoweb-stepper',
    templateUrl: './magoweb-stepper.component.html',
    styleUrls: ['./magoweb-stepper.component.scss'],
})
export class MagoWebStepperComponent implements OnInit {
    stepperOrientation: Observable<StepperOrientation>;
    privacyNotSelected: boolean = true;
    authorizationProperties: AuthorizationProperties;
    authorizationStored;

    public countrySelectedDescri: string = '';
    public countrySelectedValue: string = '';
    public selectedNrUsersValue: string = '';
    public nextString = '';
    public backString = '';
    public minCal: number;
    public isExcellencePartner;
    public administrativeInfo: Subscription;
    public subSelectedDescri: string = '';
    public functLoaded: boolean = false;
    public queryParams: Params;
    public industry: string;
    public cartRowID = '';
    public subscriptionKey = '';
    public subscriptionSelected = '';
    public language: string;
    cmsObj: CmsObject[] = [];
    public saas_title: string;
    public sft_title: string;
    public sft_description: string;
    public saas_description: string;
    public typology_intro: string;
    public selectedInstanceKey: string;
    constructor(
        private variable: TranslatedVariables,
        public magowebService: MagoWebService,
        private loginService: LoginService,
        private breakpointObserver: BreakpointObserver,
        private customerService: CustomerService,
        private cmsService: CmsService,
        public magowebLoading: LoadingService,
        public privacyAgreementService: PrivacyAgreementService,
        public configurationService: ConfigurationService,
        private activatedRoute: ActivatedRoute,
        public storeRoleService: StoreRolesService,
        private serviceUtilsService: ServiceUtilsService,
        public workFlow: WorkFlowService,
        private productService: ProductService
    ) {
        this.productService.productRelease = '';
        this.stepperOrientation = breakpointObserver
            .observe('(min-width: 1600px)')
            .pipe(map(({ matches }) => (matches ? 'horizontal' : 'vertical')));
    }

    async ngOnInit() {
        this.activatedRoute.queryParams.subscribe((params) => {
            this.magowebService.moduleCode = params.moduleCode;
            this.magowebService.version = params.version;

            this.industry = params.moduleCode;
            this.cartRowID = params.cartRowID;
            this.subscriptionSelected = params.subscriptionSelected ? atob(params.subscriptionSelected) : '';
            this.subscriptionKey = params.subKey ? atob(params.subKey) : '';
        });
        this.magowebService.productID = IndustryProductID.MW;
        await this.getCmsObj();
        this.functLoaded = false;
        this.magowebLoading.setLoading(this.functLoaded);
        this.getTranslations();
        this.authorizationStored = this.loginService.getauthinfo();
        this.authorizationProperties = JSON.parse(this.authorizationStored);
        this.administrativeInfo = this.customerService.companyInfo$.subscribe((companyInfo) => {
            if (!companyInfo) return;
            this.isExcellencePartner =
                AdministrativeInfoContainer.isPlatinumPartner(this.customerService.ListOfMandati, ProductCode.MAGOCLD) ||
                AdministrativeInfoContainer.isPlatinumPartner(this.customerService.ListOfMandati, ProductCode.MAGOWEB);
        });
        this.countrySelectedValue = this.magowebService?.countryValue;
        this.functLoaded = true;
        this.magowebLoading.setLoading(this.functLoaded);
        this.magowebService.isModifyStatus =
            this.cartRowID != undefined || (this.subscriptionKey != undefined && this.subscriptionKey.length > 0);

        if (this.magowebService.isModifyStatus) await this.getFunctionalities();
    }

    selectedDescri(countrySelectedDescri: string) {
        this.countrySelectedDescri = countrySelectedDescri;
        this.magowebService.countryDescri = this.countrySelectedDescri;
    }

    subSelected(subSelectedDescri: string) {
        this.subSelectedDescri = subSelectedDescri;
    }
    async selectedValue(countrySelectedValue: string) {
        this.countrySelectedValue = countrySelectedValue;
        this.magowebService.countryValue = countrySelectedValue;
        this.magowebService.countryDescri = await this.serviceUtilsService.getCountryDescription(countrySelectedValue);
        if (this.magowebService.currIndustryPurchInfo) this.magowebService.currIndustryPurchInfo.Country = countrySelectedValue;
        await this.getFunctionalities();
    }

    private getTranslations() {
        this.nextString = this.variable.commonsNext;
        this.backString = this.variable.commonsBack;
    }

    public async getFunctionalities() {
        this.functLoaded = false;
        this.magowebLoading.setLoading(this.functLoaded);
        //è un acquisto
        //if (this.cartRowID != undefined) {
        //this.subscriptionKey = this.subscriptionSelected;
        //await this.magowebService.loadRTMIndustryInfo(this.cartRowID, this.subscriptionKey, this.authorizationProperties.accountName);
        //} else {

        //e una internal
        if (this.subscriptionKey != undefined && this.subscriptionKey.length > 0) {
            await this.magowebService.loadInternalIndustryInfo(this.subscriptionKey, this.authorizationProperties.accountName);
        } else {
            //è nuova
            //valorizzo la release di prodotto
            if (this.productService.resellerCode.length == 0) {
                this.productService.resellerCode = this.customerService.companyInfo.CompanyCode;
            }
            await this.productService.setProductRelease(
                IndustryProductID.MW,
                Mode.rtm.toString(),
                this.magowebService.countryValue, //mi serve qui la country del reseller
                '',
                this.magowebService.moduleCode,
                this.storeRoleService.IsInternal ? '1' : '0',
                ''
            );
            await this.magowebService.loadIndustryStruct(this.authorizationProperties.accountName, this.productService.productRelease);
        }
        //}
        this.magowebService.expandSummary = true;
        this.magowebService.isAllowedToMW_MultiInstances();
        //carico le descrizioni e i titoli delle feature dal db
        await this.cmsService.getFeatureDataSheets();
        this.functLoaded = true;
        this.magowebLoading.setLoading(this.functLoaded);
    }

    public setCountryDisabled() {
        return (
            !this.magowebService.countryValue || this.magowebService.countryValue.length == 0 || this.magowebService.countryValue == 'none'
        );
    }

    public setTipologyDisabled() {
        return (
            //TODO PAOLA
            false
        );
    }

    public async updateConfiguration() {
        //this.magowebService.calculateAmounts(false);
    }

    public typeSelectionChange(event: any) {
        this.magowebService.isSFT = event.value == ConfigurationType.SFT;
        //this.magowebService.calculateAmounts(false);
    }

    public async onClickType(typeConfig: string) {
        this.magowebService.isSFT = typeConfig == ConfigurationType.SFT;
        await this.getFunctionalities();
        //await this.magowebService.calculateAmounts(true);
    }

    async getCmsObj() {
        this.language = this.workFlow.getLanguageForCms();
        //recupero le stringhe della pagina
        this.cmsObj = await this.cmsService.getCmsObj(this.language, 'MagoWeb');
        this.sft_title = this.cmsObj.find((x) => x.ContentName == 'MagoWeb.SftTitle').ContentTranslation;
        this.saas_title = this.cmsObj.find((x) => x.ContentName == 'MagoWeb.SaasTitle').ContentTranslation;
        this.sft_description = this.cmsObj.find((x) => x.ContentName == 'MagoWeb.SftDescri').ContentTranslation;
        this.saas_description = this.cmsObj.find((x) => x.ContentName == 'MagoWeb.SaasDescri').ContentTranslation;
        this.typology_intro = this.cmsObj.find((x) => x.ContentName == 'MagoWeb.TypologyIntro').ContentTranslation;
    }
    selectedInstanceDescri(selectedInstanceDescri: string) {}
    selectedInstanceValue(selectedInstanceValue: string) {
        this.selectedInstanceKey = selectedInstanceValue;
    }
    public enableButton() {
        if (this.storeRoleService.IsInternal) this.magowebService.totalCalFullNr = 1;
    }
}
